module.exports = __webpack_public_path__ + "img/19.ac1a2006.jpg";